<template>
  <v-card outlined>
    <v-container>
      <v-toolbar flat dense>
        <div>{{$t("deliveryMethod.channels")}}</div>
      </v-toolbar>
      <v-autocomplete
        v-model="eligibilityConditions.channels"
        :items="channels"
        :disabled="loading"
        :label="$t('deliveryMethod.channels')"
        class="d-flex justify-center align-center py-2"
        dense
        multiple
        hide-details="auto"
        outlined
        small-chips
        clearable
      ></v-autocomplete>
    </v-container>
  </v-card>
</template>

<script>

  export default {
    name: "channelsEligibility",
    props: {
      eligibilityConditions: {
        type: Object,
        default: null,
      },
      loading: {
        type: Boolean,
        default: false
      }
    },
    data() {
      return {
        channels: [
          { text: this.$t('order.web'), value: 'web' },
          { text: this.$t('order.shop'), value: 'shop' },
          { text: this.$t('order.marketplace'), value: 'marketplace' }
        ]
      }
    },
    computed: {
      isMobile () {
        return this.$vuetify.breakpoint.width <= 600
      },
    }
  }
</script>

